import React from "react";
import { useLocation } from "react-router-dom";
import LogoutIcon from "@Components/Icons/Logout";
import NavDashboard from "@Components/Icons/Nav/Dashboard";
import NavFile from "@Components/Icons/Nav/File";
import NavFolder from "@Components/Icons/Nav/Folder";
import NavLogOut from "@Components/Icons/Nav/LogOut";
import NavMessageChat from "@Components/Icons/Nav/MessageChat";
import NavPackage from "@Components/Icons/Nav/Package";
import NavSearch from "@Components/Icons/Nav/Search";
import NavUser from "@Components/Icons/Nav/User";
import NavUsers from "@Components/Icons/Nav/Users";
import NavZap from "@Components/Icons/Nav/Zap";
import PrimaryNav from "@Components/PrimaryNav";
import GetPath, { GetReplacements } from "@Helpers/GetPath";
import IsPathMatch from "@Helpers/IsPathMatch";
import ProposalNavigation from "@SmartComponents/Proposal/Navigation";
import { AMEND_TARIFFS, CUSTOMERS, DEALS_WON, FEEDBACK, LOGOUT, MY_ACCOUNT, MY_ORGANISATION, PROPOSAL_EDIT, PROPOSAL_SAVE, ROOT, TENDERS, TENDER_RESPONSES, } from "@Shared/Paths/Supplier";
import styles from "./index.module.scss";
const mainRoutes = [
    {
        path: ROOT,
        name: "Dashboard",
        icon: React.createElement(NavDashboard, { className: styles.icon }),
        exact: true,
        filter: (url) => !IsPathMatch(url, PROPOSAL_EDIT),
    },
    {
        path: TENDERS,
        name: "Search Tenders",
        icon: React.createElement(NavSearch, { className: styles.icon }),
        filter: (url) => !IsPathMatch(url, PROPOSAL_EDIT),
    },
    {
        path: TENDER_RESPONSES,
        name: "My Responses",
        icon: React.createElement(NavFile, { className: styles.icon }),
        filter: (url, company) => !IsPathMatch(url, PROPOSAL_EDIT) &&
            company?.incumbentCanView === undefined,
    },
    {
        path: CUSTOMERS,
        name: "Customers",
        icon: React.createElement(NavUsers, { className: styles.icon }),
        filter: (url, company) => !IsPathMatch(url, PROPOSAL_EDIT) &&
            company?.incumbentCanView === undefined,
    },
    {
        path: FEEDBACK,
        name: "Feedback",
        icon: React.createElement(NavMessageChat, { className: styles.icon }),
        filter: (url) => !IsPathMatch(url, PROPOSAL_EDIT),
    },
];
const predictInstantRoutes = [
    {
        path: AMEND_TARIFFS,
        name: "Amend Tariffs",
        icon: React.createElement(NavPackage, { className: styles.icon }),
        filter: (url) => !IsPathMatch(url, PROPOSAL_EDIT),
    },
    {
        path: DEALS_WON,
        name: "Deals Won",
        icon: React.createElement(NavZap, { className: styles.icon }),
        filter: (url) => !IsPathMatch(url, PROPOSAL_EDIT),
    },
];
const settingsRoutes = [
    {
        path: MY_ORGANISATION,
        name: "My Organisation",
        icon: React.createElement(NavFolder, { className: styles.icon }),
        filter: (url, company) => !IsPathMatch(url, PROPOSAL_EDIT) &&
            company?.incumbentCanView === undefined,
    },
    {
        path: MY_ACCOUNT,
        name: "My Account",
        icon: React.createElement(NavUser, { className: styles.icon }),
        filter: (url, company) => !IsPathMatch(url, PROPOSAL_EDIT) &&
            company?.incumbentCanView === undefined,
    },
];
const bottomRoutes = [
    {
        path: LOGOUT,
        name: "Logout",
        icon: React.createElement(NavLogOut, { className: styles.icon }),
        exact: true,
        filter: (url) => !IsPathMatch(url, PROPOSAL_EDIT),
    },
    {
        path: PROPOSAL_SAVE,
        name: "Save & Exit",
        icon: React.createElement(LogoutIcon, { className: styles.icon }),
        exact: true,
        filter: (url) => IsPathMatch(url, PROPOSAL_EDIT),
    },
];
const filterRoutes = (routes, pathname, company) => routes
    .filter(({ filter = (path, supplier) => !!path && !!supplier, }) => filter(pathname, company))
    .map((route) => {
    const replacements = GetReplacements(route.path, pathname);
    return { ...route, path: GetPath(route.path, ...replacements) };
});
export default (props) => {
    const location = useLocation();
    const pathname = location.pathname;
    const linkSections = [
        { links: filterRoutes(mainRoutes, pathname, props.company) },
        ...(props.companyLoaded && props.company?.canViewPredictInstant === true
            ? [
                {
                    title: "Predict Instant",
                    links: filterRoutes(predictInstantRoutes, pathname, props.company),
                },
            ]
            : []),
        {
            title: "Settings",
            links: filterRoutes(settingsRoutes, pathname, props.company),
        },
    ].filter(({ links }) => links.length > 0);
    const bottomRoutesFiltered = bottomRoutes
        .filter(({ filter = (path) => !!path }) => filter(pathname))
        .map((route) => {
        const replacements = GetReplacements(route.path, pathname);
        return { ...route, path: GetPath(route.path, ...replacements) };
    });
    let extra = React.createElement(React.Fragment, null), className;
    if (IsPathMatch(pathname, PROPOSAL_EDIT)) {
        extra = (React.createElement(ProposalNavigation, { responseId: pathname.replace(/.*?proposals\/(.+?)\/edit/, `$1`) }));
        className = styles.setWidth;
    }
    return (React.createElement(PrimaryNav, { linkSections: linkSections, bottomLinks: bottomRoutesFiltered, className: className, variant: "sectioned" }, extra));
};
